import {StyledSpacerRow, StyledSpacerRowSmall} from 'styles/InputMenu';
import InputActionButtons from './InputActionButtons';
import {handleKeyDown} from 'components/InputMenu/helpers';

import useAddEditFishType from 'hooks/addEdit/useAddEditFishType';
import {useInputMenuContext} from 'context/InputMenu';
import {useGetFCRModels, useGetPlanGrowthModels} from 'hooks/swr';
import useParseURL from 'hooks/useParseURL';

import {GenericSelect, GenericSelectItem} from 'components/Generic/Selectors';
import GenericTextField from 'components/Generic/TextField';
import {useTranslation} from 'react-i18next';
import Alert from '@mui/material/Alert';

function FishTypeGrowthModel() {
  const {t} = useTranslation('common');

  const {fishType, setFishType, setCreateUpdateFishType, createUpdateFishType} = useAddEditFishType();
  const {planId} = useParseURL();

  const {data: planGrowthModels} = useGetPlanGrowthModels({resourceId: planId});
  const {data: feedConversionRatioModels} = useGetFCRModels({resourceId: planId});

  const inputMenuDispatch = useInputMenuContext()?.dispatch;

  return (
    <form noValidate autoComplete="off" style={{width: '100%'}}>
      <GenericTextField
        label={t('name')}
        value={fishType.name}
        onChange={(event) => {
          const name = event.target.value;
          setFishType({...fishType, name});
        }}
        aria-label={t('name')}
        onKeyPress={(event) => inputMenuDispatch && handleKeyDown(inputMenuDispatch, event, setCreateUpdateFishType)}
        data-testid="name"
      />

      <StyledSpacerRow />

      {planGrowthModels && (
        <GenericSelect
          value={fishType.growthModelId}
          onChange={(event) => {
            const growthModelId = event.target.value as string;
            setFishType({...fishType, growthModelId});
          }}
          label={t('growthModel')}
          data-testid="growth-model-selector"
        >
          <GenericSelectItem value={undefined}>{t('noneSelected')}</GenericSelectItem>
          {planGrowthModels.map((growthModel) => (
            <GenericSelectItem key={growthModel.id} value={growthModel.id}>
              {growthModel.name}
            </GenericSelectItem>
          ))}
        </GenericSelect>
      )}

      <StyledSpacerRow />

      {feedConversionRatioModels && (
        <GenericSelect
          value={fishType.feedConversionRatioModelId}
          onChange={(event) => {
            const feedConversionRatioModelId = event.target.value as string;
            setFishType({...fishType, feedConversionRatioModelId});
          }}
          label={t('fcrModel')}
          data-testid="fcr-model-selector"
        >
          <GenericSelectItem value={undefined}>{t('noneSelected')}</GenericSelectItem>
          {feedConversionRatioModels.map((fcrModel) => (
            <GenericSelectItem key={fcrModel.id} value={fcrModel.id}>
              {fcrModel.name}
            </GenericSelectItem>
          ))}
        </GenericSelect>
      )}

      <StyledSpacerRowSmall />
      <Alert severity="info">{t('newlyCreatedFishToAllConcession')}</Alert>
      <StyledSpacerRow />

      <InputActionButtons
        setCreateUpdateInput={setCreateUpdateFishType}
        disabled={createUpdateFishType}
        loading={createUpdateFishType}
      />
    </form>
  );
}

export default FishTypeGrowthModel;
